export default __webpack_public_path__ + "static/media/plus.d25b8941.svg";